import React, {useState} from 'react';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import {grey, green, yellow, blueGrey} from '@mui/material/colors';
import {Chip, TextField, Autocomplete, FormControl} from '@mui/material';

const CustomAutocomplete = props => {
  const {
    name,
    label,
    formik,
    placeholder,
    onInputChange,
    inputValue = '',
    multiple = true,
    size = 'medium',
    fullWidth = true,
    tagColor = 'primary',
    disableheight = false,
    predefinedOptions = [],
  } = props;
  const [inputKeyword, setInputKeyword] = useState('');

  const bubbleColor = () => {
    switch (tagColor) {
      case 'green': {
        return {
          backgroundColor: green[400],
          color: 'background.paper',
        };
      }
      case 'yellow': {
        return {
          backgroundColor: yellow[400],
          color: grey[900],
        };
      }
      case 'blueGrey': {
        return {
          backgroundColor: blueGrey[400],
          color: 'background.paper',
        };
      }
      case 'purpleColor': {
        return {
          background: 'linear-gradient(#635BFF, #4E36F5)',
          color: 'white',
          '& .MuiChip-deleteIcon': {
            color: 'white',
          },
        };
      }
      default: {
        return {
          backgroundColor: 'primary.main',
          color: 'white',
          '& .MuiChip-deleteIcon': {
            color: 'white',
          },
        };
      }
    }
  };
  const handleInputChange = (_, v, r) => {
    if (r !== 'reset' && multiple) {
      setInputKeyword(v);
    }
    if (r === 'reset' && multiple && inputValue === '') {
      setInputKeyword('');
    }
    if (r === 'input') {
      setInputKeyword(v);
    }
  };

  return (
    <FormControl
      fullWidth={fullWidth}
      sx={
        disableheight
          ? {
              height: 'auto',
            }
          : {
              height: 55,
            }
      }>
      <Autocomplete
        multiple
        freeSolo
        size={size}
        limitTags={2}
        openOnFocus={false}
        forcePopupIcon={true}
        options={predefinedOptions}
        value={formik.values[name] || []}
        popupIcon={<ArrowDropDownIcon />}
        inputValue={inputValue || inputKeyword}
        open={inputKeyword.length >= 2 || false}
        onInputChange={onInputChange ? onInputChange : handleInputChange}
        getOptionLabel={option =>
          typeof option === 'string' ? option : option.label
        }
        filterOptions={(options, state) => {
          const input = state.inputValue.toLowerCase();
          return options.filter(option =>
            option.label.toLowerCase().includes(input)
          );
        }}
        sx={{
          '& .MuiInputBase-input': {
            border: '0px !important',
          },
          '& .MuiAutocomplete-endAdornment': {
            visibility: 'visible',
          },
        }}
        slotProps={{
          paper: {
            sx: {borderTop: `1px solid ${grey[700]}`},
          },
        }}
        onChange={(_, value) => {
          // Normalize to string array
          const normalized = value.map(item =>
            typeof item === 'string' ? item : item.label
          );
          formik.setFieldValue(name, normalized);
        }}
        renderTags={(value, getTagProps) =>
          value.map((option, index) => (
            <Chip
              variant="outlined"
              sx={bubbleColor()}
              label={option?.label || option}
              {...getTagProps({index})}
              key={option}
            />
          ))
        }
        renderInput={params => (
          <TextField
            {...params}
            name={name}
            label={label}
            variant="outlined"
            placeholder={placeholder}
            onBlur={formik.handleBlur}
            helperText={formik.touched[name] && formik.errors[name]}
            error={formik.touched[name] && Boolean(formik.errors[name])}
          />
        )}
      />
    </FormControl>
  );
};

export default CustomAutocomplete;
